import {
  TableCell,
  Typography,
  type SxProps,
  type Theme,
  type TableCellProps,
} from "@mui/material";

import {
  StyledTableHeaderCell,
  HeaderCellContent,
} from "@/components/DataTable.styles";

export const TableHeaderWrapper = ({
  onClick,
  isSortable,
  children,
  colSpan,
  sx,
}: {
  onClick?: () => void;
  isSortable: boolean;
  children?: React.ReactNode;
  colSpan?: number;
  sx?: SxProps<Theme> | undefined;
}) => {
  return (
    <StyledTableHeaderCell
      onClick={onClick}
      isSortable={isSortable}
      colSpan={colSpan}
      sx={sx}
    >
      <HeaderCellContent>
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {children}
        </Typography>
      </HeaderCellContent>
    </StyledTableHeaderCell>
  );
};

interface TableCellWrapperProps extends TableCellProps {
  children: React.ReactNode;
}

export const TableCellWrapper = ({
  children,
  sx: sxOverride,
  ...props
}: TableCellWrapperProps) => {
  const baseSx: SxProps<Theme> = {
    py: 3,
    px: 3,
    border: "none",
    borderRight: "none",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: 0,
  };

  return (
    <TableCell
      sx={sxOverride ? [baseSx, sxOverride].flat() : baseSx}
      {...props}
    >
      <Typography
        component="div"
        variant="body1"
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {children}
      </Typography>
    </TableCell>
  );
};
